import { PATH } from '@/app/routes';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useHandleDocumentNavigate = () => {
  const nav = useNavigate();

  const handleNavigate = useCallback(
    ({ id, url, fileName, createdAt }: { id: string; createdAt: string; url: string; fileName: string }) => {
      const params = new URLSearchParams({ id, url, fileName, createdAt });
      nav(`${PATH.documentView}?${params.toString()}`);
    },
    [nav],
  );

  return { handleNavigate };
};
